<p-dialog class="onramper-modal" header="Header" [(visible)]="visible"
    [breakpoints]="{ '1080px': '75vw', '560px':'90vw' }" [style]="{ width: '50vw',maxWidth:'420px' }" (onHide)="onHide()"
    [modal]="true"  [dismissableMask]="true">
    <ng-template pTemplate="header">
        <span></span>
    </ng-template>
    <div class="">
        <iframe style="border-radius: 4px; border: 1px solid #58585f; margin: auto;max-width: 420px" [src]="srcOnramper"
            height="630px" width="100%" title="Onramper widget"
            allow="accelerometer; autoplay; camera; gyroscope; payment" class="iframe-onramper">
        </iframe>
    </div>
</p-dialog>